module.exports = __webpack_public_path__ + "img/banner_8.d593d746.png";